import Divider from '@material-ui/core/Divider';
import React from 'react';
import HttpServerSettingsMenuItem from '../http-server/HttpServerSettingsMenuItem';

function FileSection({ isMachineDetailPage }) {
	return isMachineDetailPage ? (
		<React.Fragment>
			<Divider />
			<HttpServerSettingsMenuItem />
		</React.Fragment>
	) : null;
}

export default FileSection;



// WEBPACK FOOTER //
// /home/travis/build/cedalo/streamsheets-pro-features/packages/webui-extensions/src/MainDrawerExtensions/StreamSection.js